module.exports = __webpack_public_path__ + "static/media/confettis.cb4ee768.png";